export { type AccordionProps, default as Accordion } from './Accordion';
